import { create } from 'zustand';

export interface GameCardGuideConfig {
  enabled: boolean;
  guideText: string;
  guideIcon: string;
  noGiftButtonText: string;
  guideUrl: string;
  isOrderRequired: boolean;
}

interface GameCardGuideStore extends GameCardGuideConfig {
  unsupportedReason?: number;
  setUnsupportedReason: (reason?: number) => void;
  initGameCardGuideConfig: (config: Partial<GameCardGuideConfig>) => void;
  isGuideAvailable: () => boolean;
}

export const useGameCardGuideStore = create<GameCardGuideStore>((set, get) => ({
  enabled: false,
  guideText: '',
  guideIcon: '',
  noGiftButtonText: '',
  guideUrl: '',
  isOrderRequired: false,
  unsupportedReason: 0,

  setUnsupportedReason: (reason?: number) => set({ unsupportedReason: reason }),

  initGameCardGuideConfig: (config: Partial<GameCardGuideConfig>) => set({ ...config }),

  isGuideAvailable: () => {
    const { enabled, noGiftButtonText, guideUrl } = get();
    return enabled && !!noGiftButtonText && !!guideUrl;
  },
}));
